import React from "react";
import { logEvent, serializeError } from "../../utils/logger";

/**
 * Error Boundary global — attrape les crashs React non gérés.
 * Envoie un log CRITICAL vers le monitoring centralisé.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    logEvent("CRITICAL", "UI", "React Tree Crashed", {
      error: serializeError(error),
      componentStack: errorInfo?.componentStack || null,
      reactVersion: React.version,
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            padding: "40px",
            textAlign: "center",
            fontFamily: "system-ui, sans-serif",
            color: "#333",
          }}
        >
          <h1 style={{ fontSize: "1.5rem", marginBottom: "16px" }}>
            Une erreur inattendue est survenue
          </h1>
          <p style={{ fontSize: "1rem", marginBottom: "24px", color: "#666" }}>
            Nous en avons été informés et travaillons à la résoudre.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              padding: "12px 24px",
              fontSize: "1rem",
              backgroundColor: "#4a7c59",
              color: "white",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Recharger la page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
